module.exports = __webpack_public_path__ + "static/media/bg.752b34ba.png";